import { Injectable } from '@angular/core'
import { Response } from '@angular/http'
import { Observable } from 'rxjs/Observable'
import { Angular2TokenService, AuthData } from 'angular2-token'
import { Router } from '@angular/router'

import { IAuthentication } from './i-authentication.service'
import { CurrentUser } from 'models'
import { AppHttpBroadcaster } from 'core/http'
import { Constants } from 'config'

@Injectable()
export class Authentication extends IAuthentication {
  private _currentUser: CurrentUser = null

  constructor(private tokenService: Angular2TokenService, private appHttpBroadcaster: AppHttpBroadcaster, private router: Router) {
    super()

    this.appHttpBroadcaster.errors().subscribe(error => {
      if(error.status == 401 && router.url != Constants.PAGE_PATHS.SIGN_IN) {
        this.currentUser = null
        this.tokenService.signOut()
        this.router.navigateByUrl(Constants.PAGE_PATHS.SIGN_IN)
      }
    })
  }

  get currentUser(): CurrentUser {
    return this._currentUser
  }

  set currentUser(user: CurrentUser) {
    this._currentUser = user
  }

  get currentAuthData(): AuthData {
    return this.tokenService.currentAuthData
  }

  validateToken(): Observable<Response> {
    return Observable.create(observer => {
      this.tokenService.validateToken().subscribe(
        response => {
          let data = response.json()
          this.currentUser = new CurrentUser(data['data']['user'])
          observer.next(response)
          observer.complete()
        },
        error => {
          observer.error(error)
        }
      )
    })
  }

  signIn(email: string, password: string): Observable<Response> {
    return Observable.create(observer => {
      this.tokenService.signIn({email: email, password: password})
        .subscribe(
          response => {
            let data = response.json()
            this.currentUser = new CurrentUser(data['data']['user'])
            observer.next(response)
            observer.complete()
          },
          error => {
            observer.error(error)
          }  
        )
    })
  }

  signOut(): Observable<Response> {
    return Observable.create(observer => {
      this.tokenService.signOut()
        .subscribe(
          response => {
            this.currentUser = null
            observer.next(response)
            observer.complete()
          },
          error => {
            observer.error(error)
          }  
        )
    })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/auth/authentication.service.ts